module.exports = "https://web-assets.ifttt.com/packs/media/subscriptions/success_illustration-00a5ac2a.svg";